import React from 'react';

import BenchlingConfig from 'BenchlingConfig';

export default function GenomeImportHelpText(): JSX.Element {
  if (!BenchlingConfig.ENABLE_REQUEST_GENOMES) {
    return <></>;
  }

  return (
    <span className="genomeImport-text">
      <span>Don't see the genome you're looking for? We may be able to import it, </span>
      <a href="https://www.getfeedback.com/r/Ys4EkoOf" target="_blank" rel="noopener noreferrer">
        just ask.
      </a>
    </span>
  );
}
